// apps/merchant-v3/src/lib/i18n/I18nProvider.tsx
//
// Phase 6 Wave 2 Task 06 — Wraps the SPA in <I18nextProvider>. Also
// reconciles the active locale with the authenticated user's
// `user.language` field whenever it changes (so server-truth wins on
// page reload after a profile PATCH from another tab). When the user
// is anonymous, the LanguageDetector cookie/localStorage chain takes
// over.
//
// vg-binding: PLAN:task-06
// vg-binding: P6.D-131
// vg-binding: P6.D-221

import { useEffect, type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { i18n, userLangToLocale } from './index';
import { useUser } from '@/store/user';

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps): JSX.Element {
  const user = useUser();
  useEffect(() => {
    if (!user?.language) return;
    const target = userLangToLocale(user.language);
    if (i18n.language !== target) {
      void i18n.changeLanguage(target);
    }
  }, [user?.language]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export default I18nProvider;
